var render = function render(){var _vm=this,_c=_vm._self._c;return _c('open-banking-description-step',{staticClass:"obk-description-id-note-step",attrs:{"step-number":_vm.stepNumber},scopedSlots:_vm._u([{key:"text",fn:function(){return [_c('div',[_vm._v("חשוב לשים לב שמספר הת.ז של בעל הכרטיס באתר חברת האשראי הוא אותו מספר שהקלדת ברייזאפ")])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }